export default "__VITE_ASSET__ed334650__"